/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Save_TitleInputs */

const en_pc_tut_save_title = /** @type {(inputs: Pc_Tut_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save, autosave and crash recovery`)
};

const zh_pc_tut_save_title = /** @type {(inputs: Pc_Tut_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存、自动保存与崩溃恢复`)
};

/**
* | output |
* | --- |
* | "Save, autosave and crash recovery" |
*
* @param {Pc_Tut_Save_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_save_title = /** @type {((inputs?: Pc_Tut_Save_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Save_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_save_title(inputs)
	return zh_pc_tut_save_title(inputs)
});
export { pc_tut_save_title as "pc.tut.save.title" }